var $ = require('jquery');
var Storage = require('../common/storage');
var EntriesTemplate = require('./entries.hbs');

function QueueEntriesRequest() {
	return {
		page: 1,
		sortname: 'id',
		sortorder: 'DESC'
	};
}

function QueueEntries() {

	var storageKey = 'system.queueEntries.request';

	var selectors = {
		container: '#queueEntries_container',
		indicator: '#indicator'
	};

	var request = getOrCreateRequest();

	function newRequest() {
		return new QueueEntriesRequest();
	}

	function getOrCreateRequest() {
		var request = Storage.Session.getItem(storageKey);
		if (!request) {
			request = newRequest();
		}
		return request;
	}

	function saveRequestAndLoad() {
		saveRequest();
		load();
	}

	function saveRequest() {
		Storage.Session.setItem(storageKey, request);
	}

	function requeue(id, callback) {
		$.post(
			'../../api/system/requeue/' + id,
			function (data) {
				if (callback && typeof callback === 'function') {
					callback();
				}
			}
		)
	}

	function load() {
		$.get(
			'../../api/system/queueEntries',
			{page: request.page, sort: request.sortname, order: request.sortorder},
			function (data) {
				var mapped = (data.data || []).map(function (d) {
					return Object.assign({}, d, {
						isError: d.status == -2,
						isInterrupted: d.status == -1,
						isQueued: d.status == 0,
						isRunning: d.status == 1,
						isSuccess: d.status == 2,
					});
				});
				var page = {
					number: request.page,
					count: parseInt(data.pages),
					isFirst: request.page === 1,
					isLast: request.page === parseInt(data.pages)
				};

				$(selectors.indicator).attr('style', 'display:none');
				$(selectors.container).html(EntriesTemplate({data: mapped, page: page}));

				$('[data-payload]').on('click', function () {
					var index = $(this).attr('data-payload');
					$('#payloadModal').find('code').text(mapped[index].payload);
				});

				$('[data-log]').on('click', function () {
					var index = $(this).attr('data-log');
					$('#logModal').find('code').text(mapped[index].log);
				});

				$('[data-requeue]').on('click', function (e) {
					var id = $(this).attr('data-requeue');
					requeue(id, function() {
						saveRequestAndLoad();
					});
					e.preventDefault();
					return false;
				});

				$('#pager_first').on('click', function() {
					if (request.page != page.count) {
						request.page = page.count;
						saveRequestAndLoad();
					}
				});
				$('#pager_previous').on('click', function() {
					if (request.page < page.count) {
						request.page++;
						saveRequestAndLoad();
					}
				});
				$('#pager_next').on('click', function() {
					if (request.page > 1) {
						request.page--;
						saveRequestAndLoad();
					}
				});
				$('#pager_last').on('click', function() {
					if (request.page != 1) {
						request.page = 1;
						saveRequestAndLoad();
					}
				});
			},
			'json'
		);
	}

	load();
}

module.exports = QueueEntries;
